import { render, staticRenderFns } from "./patrol-add.vue?vue&type=template&id=812d0758&scoped=true&"
import script from "./patrol-add.vue?vue&type=script&lang=js&"
export * from "./patrol-add.vue?vue&type=script&lang=js&"
import style0 from "./patrol-add.vue?vue&type=style&index=0&id=812d0758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812d0758",
  null
  
)

export default component.exports